export function isUserAuthenticated() {
    const usuario = localStorage.getItem('usuario');
    return !!usuario; // Retorna true se o usuário existir, false caso contrário
  }
  